/**
 * Auditoria — visão mobile (read-only) para gestão/AUDIN no celular. Mesmo
 * endpoint da tela desktop; feed em cards com busca + "carregar mais".
 */
import { Header } from "@caint/design-system";
import { useCallback, useEffect, useState } from "react";
import type { EventoAuditoria } from "../lib/api.ts";
import { ApiError, apiClient } from "../lib/api.ts";
import { mensagemAmigavel } from "../lib/erros.ts";

function quando(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const LIMITE = 30;

export function AuditoriaMobile({ token, onBack }: { token: string | null; onBack: () => void }) {
  const [q, setQ] = useState("");
  const [eventos, setEventos] = useState<EventoAuditoria[]>([]);
  const [temMais, setTemMais] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const carregar = useCallback(
    async (offset: number) => {
      if (!token) {
        return;
      }
      setCarregando(true);
      setErro(null);
      try {
        const r = await apiClient.auditoria({ q: q || undefined, offset, limite: LIMITE }, token);
        setEventos((prev) => (offset === 0 ? r.eventos : [...prev, ...r.eventos]));
        setTemMais(r.temMais);
      } catch (e) {
        setErro(e instanceof ApiError ? mensagemAmigavel(e) : "Falha ao carregar a auditoria.");
      } finally {
        setCarregando(false);
      }
    },
    [token, q],
  );

  useEffect(() => {
    void carregar(0);
  }, [carregar]);

  return (
    <>
      <Header title="Auditoria" sub="Tudo que muda — quem, o quê, quando" onBack={onBack} />
      <div className="m-body">
        <input
          type="search"
          className="m-input"
          placeholder="Buscar por item, motivo, nome…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ marginBottom: 12 }}
        />
        {erro && <p style={{ color: "var(--danger)" }}>{erro}</p>}
        {eventos.length === 0 && !carregando && (
          <p style={{ color: "var(--text-muted)", fontSize: 14 }}>Nenhum evento.</p>
        )}
        <div style={{ display: "grid", gap: 8 }}>
          {eventos.map((e) => (
            <div
              key={e.id}
              style={{
                border: "1px solid var(--border, #d7ddde)",
                borderRadius: 12,
                padding: "10px 12px",
                background: "#fff",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 12 }}>
                <b>{e.acao}</b>
                <span style={{ color: "var(--text-muted)" }}>{quando(e.em)}</span>
              </div>
              <div style={{ fontSize: 13, marginTop: 4 }}>{e.resumo ?? "—"}</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 4 }}>
                {(e.autorNome ?? e.autorId ?? "—") + (e.entidadeId ? ` · ${e.entidadeId}` : "")}
              </div>
            </div>
          ))}
        </div>
        {temMais && (
          <button
            type="button"
            className="m-btn"
            disabled={carregando}
            onClick={() => void carregar(eventos.length)}
            style={{ marginTop: 12, width: "100%" }}
          >
            {carregando ? "Carregando…" : "Carregar mais"}
          </button>
        )}
      </div>
    </>
  );
}
